const Rows = ({ children }) => {
    return  (
        <tbody className="main-list__table-body">
            {children}
        </tbody>
    );
};

export default Rows;
